<div class="min-h-screen bg-gray-50 flex items-center justify-center">
    <div class="text-center space-y-8 max-w-2xl px-4">
        <div class="relative mx-auto w-64 h-64">
            <img src="/callback.webp" alt="Authentication in progress" class="w-full h-full object-contain" />

            <div class="absolute inset-0 flex items-start justify-end pr-[70px] pt-[115px]">
                <div class="w-8 h-8 border-2 border-stone-500 border-t-transparent rounded-full animate-spin" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <div class="prose prose-lg">
            <h2 class="text-gray-900 font-semibold animate-pulse">Authenticating...</h2>
            @if (message) {
                <p class="text-gray-600 mt-2">
                    {{ message }}
                </p>
            }
        </div>
    </div>
</div>
